import { NavLink, Outlet } from 'react-router-dom';
import { useAuth } from '../auth';
import { useI18n } from '../i18n';
import { Icon } from './icons';

export function Layout() {
  const { user, logout } = useAuth();
  const { t, lang, setLang } = useI18n();
  const links = [
    { to: '/', label: t('nav.home'), icon: Icon.home, end: true },
    { to: '/events', label: t('nav.events'), icon: Icon.calendar },
    { to: '/equipment', label: t('nav.equipment'), icon: Icon.box },
    { to: '/kits', label: t('nav.kits'), icon: Icon.case },
    { to: '/timesheets', label: t('nav.timesheets'), icon: Icon.clock },
    { to: '/crew', label: t('nav.crew'), icon: Icon.people },
    { to: '/interpreters', label: t('nav.interpreters'), icon: Icon.headset },
    { to: '/venues', label: t('nav.venues'), icon: Icon.pin },
    { to: '/clients', label: t('nav.clients'), icon: Icon.building },
  ];
  return (
    <div className="shell">
      <aside className="sidebar no-print">
        <div className="brand">
          <img src="/logo.png" alt="Translation Centre" />
          <div className="sub">Desk</div>
        </div>
        <nav className="nav" aria-label={t('nav.main')}>
          {links.map((l) => (
            <NavLink key={l.to} to={l.to} end={l.end}>
              <l.icon />
              {l.label}
            </NavLink>
          ))}
        </nav>
        <div className="foot">
          <div className="small">
            <strong>{user?.name}</strong>
            <div className="muted">{t(`role.${user?.role}`)}</div>
          </div>
          <div className="row">
            <NavLink to="/settings" className="btn btn-sm">
              <Icon.settings />
              {t('nav.settings')}
            </NavLink>
            <button className="btn btn-sm" onClick={() => setLang(lang === 'sq' ? 'en' : 'sq')} aria-label={t('nav.switchLanguage')}>
              {lang === 'sq' ? 'EN' : 'SQ'}
            </button>
            <button className="btn btn-sm btn-ghost" onClick={logout}>
              <Icon.logout />
              {t('nav.logout')}
            </button>
          </div>
        </div>
      </aside>
      <main className="main">
        <Outlet />
      </main>
    </div>
  );
}
